import * as betgalaxy from './GetVerified.styles.betgalaxy';
import { EThemesOG } from '@/constants/themeConfig';

export const styleImports: Partial<Record<EThemesOG, any>> = {
  betgalaxy,
};
